// Static option catalogs and form defaults for the proposals page.
// Extracted verbatim from RentFlowsIndex.vue: labels/values are pinned by parity specs.
import {
  DEFAULT_FINANCING_ANNUAL_RATE,
  DEFAULT_FINANCING_TERM_MONTHS,
  isFinancingPaymentKind,
} from 'dashboard/helper/lais/paymentInfo';

export const offerKindValues = ['all', 'offer', 'booking'];

export const offerSortValues = [
  'recent_activity',
  'arrival_date',
  'higher_value',
  'lower_value',
];

export const paymentKindValues = [
  'all',
  'a_vista',
  'financiamento',
  'a_vista_fgts',
  'financiamento_fgts',
];

export const offerBuckets = [
  { value: 'in_negotiation', label: 'Em andamento' },
  { value: 'canceled', label: 'Canceladas' },
  { value: 'finished', label: 'Finalizadas' },
];

export const paymentOptions = [
  { value: 'a_vista', label: 'À vista' },
  { value: 'financiamento', label: 'Financiado' },
  { value: 'a_vista_fgts', label: 'À vista + FGTS' },
  { value: 'financiamento_fgts', label: 'Financiado + FGTS' },
];

export const offerKindOptions = [
  { value: 'all', label: 'Todas' },
  { value: 'offer', label: 'Proposta' },
  { value: 'booking', label: 'Reserva' },
];

export const offerSortOptions = [
  { value: 'recent_activity', label: 'Atividade mais recente' },
  { value: 'arrival_date', label: 'Data de entrada' },
  { value: 'higher_value', label: 'Maior valor' },
  { value: 'lower_value', label: 'Menor valor' },
];

export const isFinancingPayment = value => isFinancingPaymentKind(value);

export const paymentLabel = value =>
  paymentOptions.find(option => option.value === value)?.label ||
  'Pagamento não informado';

export const paymentNeedsFgts = value =>
  ['a_vista_fgts', 'financiamento_fgts'].includes(value);

export const declineReasonOptions = [
  {
    value: 'conditions_not_agreed',
    label: 'Não concordo com as condições propostas',
  },
  {
    value: 'residents_not_agreed',
    label: 'Não concordo com o número de moradores',
  },
  { value: 'picked_another_offer', label: 'Escolhi outra proposta' },
  {
    value: 'rented_outside_imudei',
    label: 'Já aluguei o imóvel por fora da Imudei',
  },
  {
    value: 'gave_up_renting',
    label: 'Desisti de alugar este imóvel',
  },
  {
    value: 'not_owner_anymore',
    label: 'Não sou mais proprietário deste imóvel',
  },
  {
    value: 'owner_conditions_not_agreed',
    label: 'O proprietário não concorda com as condições propostas',
  },
  {
    value: 'owner_residents_not_agreed',
    label: 'O proprietário não concorda com o número de moradores',
  },
  {
    value: 'owner_picked_another_offer',
    label: 'O proprietário escolheu outra proposta',
  },
  {
    value: 'owner_rented_outside_imudei',
    label: 'O imóvel foi alugado por fora da Imudei',
  },
  {
    value: 'owner_gave_up_renting',
    label: 'O proprietário desistiu de alugar este imóvel',
  },
  {
    value: 'property_no_longer_owned',
    label: 'Esse imóvel não pertence mais ao proprietário',
  },
  {
    value: 'buyer_preferred_other_property',
    label: 'Interessado preferiu outro imóvel',
  },
  {
    value: 'buyer_gave_up_purchase',
    label: 'Interessado desistiu da compra',
  },
  {
    value: 'documentation_problem',
    label: 'Problemas na documentação do interessado',
  },
  { value: 'payment_disagreement', label: 'Falta de acordo sobre pagamento' },
  { value: 'financing_problem', label: 'Problemas com financiamento' },
  { value: 'fgts_problem', label: 'Problemas com FGTS' },
  { value: 'other', label: 'Outro motivo' },
];

export const rentalDeclineReasons = [
  'conditions_not_agreed',
  'residents_not_agreed',
  'picked_another_offer',
  'rented_outside_imudei',
  'gave_up_renting',
  'not_owner_anymore',
  'owner_conditions_not_agreed',
  'owner_residents_not_agreed',
  'owner_picked_another_offer',
  'owner_rented_outside_imudei',
  'owner_gave_up_renting',
  'property_no_longer_owned',
];

export const createSteps = [
  { value: 'property', label: 'Imóvel' },
  { value: 'buyer', label: 'Interessado' },
  { value: 'values', label: 'Valores' },
  { value: 'review', label: 'Revisão' },
];

export const customSolicitationTypeOptions = [
  { value: '', label: 'Sem ajustes no imóvel' },
  { value: 'Adicionar', label: 'Solicitou adicionar itens no imóvel' },
  { value: 'Remover', label: 'Solicitou remover itens do imóvel' },
  { value: 'Reparar', label: 'Solicitou reparar itens no imóvel' },
  { value: 'Modificar', label: 'Solicitou modificar itens no imóvel' },
];

export const defaultProposalForm = () => ({
  kind: 'offer',
  business_context: 'purchase',
  offer_amount: '',
  financed_amount: '',
  contact_id: null,
  requester_name: '',
  requester_email: '',
  requester_phone: '',
  earnest_payment_amount: '',
  entry_amount: '',
  cash_amount: '',
  fgts_amount: '',
  brokerage_fee_value: '',
  itbi_amount: '',
  itbi_overridden: false,
  notary_fee_value: '',
  notary_fee_overridden: false,
  financing_term_months: DEFAULT_FINANCING_TERM_MONTHS,
  financing_annual_rate: DEFAULT_FINANCING_ANNUAL_RATE,
  rent_iptu_amount: '',
  rent_condominium_amount: '',
  admin_fee_percentage: '10',
  minimum_admin_fee: '',
  residents_count: '1',
  has_pets: false,
  custom_solicitation_type: '',
  custom_solicitation_description: '',
  response_deadline_date: '',
  first_purchase: false,
  has_sfh: false,
  payment_kind: 'a_vista',
  notes: '',
});
